<template>
  <Icon-Template :size="size">
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.59 13.41L8.47 15.53C7.38 16.62 5.62 16.62 4.53 15.53C3.44 14.44 3.44 12.68 4.53 11.59L7.05 9.05C8.14 7.96 9.9 7.96 10.99 9.05L11.29 9.35L12.71 7.93L12.41 7.63C10.73 5.95 7.76 5.95 6.08 7.63L3.56 10.15C1.88 11.83 1.88 14.8 3.56 16.48C5.24 18.16 8.21 18.16 9.89 16.48L12 14.35L10.59 13.41ZM14.11 10.99L13.71 10.59L12.29 12L12.59 12.29C14.27 13.97 17.24 13.97 18.92 12.29L21.44 9.77C23.12 8.09 23.12 5.12 21.44 3.44C19.76 1.76 16.79 1.76 15.11 3.44L13 5.57L14.41 6.59L16.53 4.47C17.62 3.38 19.38 3.38 20.47 4.47C21.56 5.56 21.56 7.32 20.47 8.41L17.95 10.93C16.86 12.02 15.1 12.02 14.01 10.93L13.71 10.63L12.29 12L12.59 12.29L14.11 10.99ZM9.29 14.71L10.71 16.12L14.71 12.12L13.29 10.71L9.29 14.71Z" fill="currentColor"/>
</svg>

  </Icon-Template>
</template>

<script>
import IconTemplate from '@/components/icons/Template';

export default {
  props: ['size'],
  components: { IconTemplate }
}
</script>
